import { ArraySerializer, Field, Model, Type } from 'serialize-ts';
import { ProductIndexPromotionItem } from '~app/modules/product/models/product-index-promotion-item.interface';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';
import { ProductIndexOffer } from '~app/modules/product/models/product-index-offer.model';

@Model()
export class ProductIndexPromotion {
  @Field()
  active: boolean;

  @Field()
  endDate: string;

  @Field()
  nextChangeDate: string;

  @Type(new ArraySerializer(new ModelMetadataSerializer(ProductIndexPromotion)))
  items: ProductIndexPromotionItem[];
}
